"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateEmail;
var emailPattern = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}$/;

function validateEmail(value) {
  return emailPattern.test(value);
}